<template>
  <draggable
    tag="ul"
    class="selected-participant-fields flex flex-col gap-2"
    v-model="participantFields"
    handle=".drag-section"
  >
    <li class="flex gap-2 justify-between" v-for="(item) in participantFields" :key="item.id">
      <section class="field flex border border-gray-40 rounded-lg flex-1">
        <section class="pl-2 max-w-32 w-32 name-section border-r border-gray-40 flex items-center">
          <aha-antd-button
            name="drag-participant-field-button"
            v-aha-emit-action
            class="drag-section"
            icon-name="aha-drag"
            icon-view-box="0 0 16 16"
            variant="tertiary"
            size="sm"
          />
          <span
            :title="item.name"
            class="cursor-default px-2 min-w-22 max-w-22 truncate"
            :class="{
              'capitalize': item.isSystemField,
            }"
          >{{ item.name }}</span>
        </section>
        <section class="label-section flex-1 flex items-center gap-2">
          <aha-input
            :title="item.label"
            :value="item.label"
            :maxLength="100"
            hideCharacterCounter
            @input="(value) => {
              item.label = value
              updateFieldDetail()
            }"
          />
          <div
            v-if="item.required || item.hidden"
            class="indicator-container flex flex-col gap-1"
          >
            <aha-icon
              v-if="item.required"
              name="aha-asterisk"
              class="text-pink-100 min-w-3"
              strokeColor
              maintainColor
              width="12"
              height="12"
              viewBox="0 0 16 16"
            >
            </aha-icon>
            <aha-icon
              v-if="item.hidden"
              name="aha-eye-slash"
              class="text-pink-100 min-w-3"
              strokeColor
              maintainColor
              width="12"
              height="12"
              viewBox="0 0 16 16"
            >
            </aha-icon>
          </div>
          <span v-if="item.required || item.hidden"></span>
        </section>
      </section>
      <section class="action-section">
        <SelectedParticipantFieldsContextMenu>
          <template #trigger>
            <aha-antd-button
              name="open-participant-field-action-dropdown"
              v-aha-emit-action
              icon-name="aha-dots-vertical"
              icon-view-box="0 0 16 16"
              variant="secondary"
              size="lg"
            />
          </template>
          <template #items>
            <aha-context-menu-item
              name="toggle-required-field"
              v-aha-emit-action
              @click="handleClickRequiredField(item)"
            >
              <span>
                {{
                  item.required ? $i18nPresenter.t('Mark as optional') : $i18nPresenter.t('Mark as required')
                }}
              </span>
            </aha-context-menu-item>
            <aha-context-menu-item
              v-if="showToggleField"
              :name="item.hidden ? 'show-participant-field' : 'hide-participant-field'"
              v-aha-emit-action
              @click="handleToggleField(item)"
            >
              <span>{{ item.hidden ? $i18nPresenter.t('Show on slide') : $i18nPresenter.t('Hide on slide') }}</span>
            </aha-context-menu-item>
            <aha-context-menu-item
              name="remove-participant-field"
              v-aha-emit-action
              @click="handleDeleteField(item)"
            >
              <span class="text-pink-100">{{ $i18nPresenter.t('Remove') }}</span>
            </aha-context-menu-item>
          </template>
        </SelectedParticipantFieldsContextMenu>
      </section>
    </li>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'
import { mapActions } from 'vuex'
import SelectedParticipantFieldsContextMenu from '@/components-v2/presentation-editor/side-right/SelectedParticipantFieldsContextMenu.vue'

const UPDATE_EVENT = 'update:selectedParticipantFields'
const TOGGLE_EVENT = 'toggle:selectedParticipantFields'

export default {
  components: {
    draggable,
    SelectedParticipantFieldsContextMenu,
  },
  props: {
    selectedFields: {
      type: Array,
      default: () => [],
    },
    presentationId: {
      type: Number,
      default: null,
    },
    showToggleField: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    participantFields: {
      get() {
        return this.selectedFields
      },
      set(value) {
        this.$emit(UPDATE_EVENT, value)
      },
    },
  },
  methods: {
    ...mapActions('presentationSetting', ['updateParticipantInfoFields']),
    updateFieldDetail() {
      this.updateParticipantInfoFields({
        presentationId: this.presentationId,
        updatedFields: {
          fields: this.selectedFields,
        },
      })
    },
    handleToggleField(field) {
      const updatedFields = this.selectedFields.map((f) => {
        if (f.id === field.id) {
          return {
            ...f,
            hidden: !f.hidden,
          }
        }
        return f
      })
      this.$emit(UPDATE_EVENT, updatedFields)
      this.$emit(TOGGLE_EVENT, field)
    },
    handleDeleteField(field) {
      const filteredFields = this.selectedFields.filter((f) => f.id !== field.id)
      this.$emit(UPDATE_EVENT, filteredFields)
    },
    handleClickRequiredField(field) {
      this.$emit(UPDATE_EVENT, this.selectedFields.map((f) => {
        if (f.id === field.id) {
          return {
            ...f,
            required: !f.required,
          }
        }
        return f
      }))
    },
  },
}
</script>
<style lang="scss" scoped>
.selected-participant-fields {
  &::v-deep .aha-input {
    border: none;
    background: transparent;
    height: 100%;
  }

  &::v-deep .aha-input__wrapper {
    height: 100%;
  }
}

ul {
    padding: 0;
    margin: 0;
}

.flex {
    display: flex;
    flex-basis: content;
}
</style>
